import { TaskService } from '../services/taskService.js.erb';
import { dateCountHelper } from '../../../../../javascripts/helpers/dateCountHelper';
import { ERROR_TYPES, TASK_STATUS } from '../tasksConsts';

const apiService = TaskService

export const tasksStore = {
  namespaced: true,
  state: {
    taskCount: 0,
    tasks: [],
    dateSelected: new Date(),
    loading: false,
    urlBase: "",
    tenantPresent: false,
    error: {
      hasError: false,
      errorType: null
    }
  },
  mutations: {
    'SET_TASKS'(state, data){
      data = data.map((task, index) => {
        if(task.finished_at != null){
          task["timerState"]=4
        }else{
          task["timerState"]=TASK_STATUS.stopped
        }
        task["isLoading"]=false
        task["created"]=true
        task["editing"]=false
        task["error"] = {
          hasError: false,
          errorType: null,
        }
        task["renderId"]=dateCountHelper(state.dateSelected, index)
        console.log(task.tags)
        return task
      });
      state.taskCount = data.length;
      state.tasks = [...data] 
    },
    'SET_TENANT_PRESENT'(state, tenantPresent){
      state.tenantPresent=tenantPresent
    },
    'SET_URL_BASE'(state, urlBase){
      state.urlBase = urlBase
    },
    'CREATE_TASK'(state, {renderId, data}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(t => t.renderId==renderId)
      data["isLoading"]=false
      data["timerState"]=TASK_STATUS.stopped
      data["renderId"]=renderId
      data["created"]=true
      data["editing"]=false
      data["error"] = {
        hasError: false,
        errorType: null,
      }
      tasks[task_index] = {...data}
      state.tasks = [...tasks]
    },
    'NEW_TASK'(state){
      let tasks = [...state.tasks]
      state.taskCount = state.taskCount+1
      tasks.unshift({
        title: "",
        description: "",
        duration: 0,
        tags: [],
        editing: false,
        renderId: dateCountHelper(state.dateSelected, state.taskCount),
        created: false,
        error: {
          hasError: false,
          errorType: null,
        },
      })
      state.tasks = [...tasks];
    },
    'EDIT_TASK'(state, {task_id}){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index].editing=true
    },
    'UPDATE_TASK'(state, {task_id, data}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(task => task["id"]==task_id)
      data["isLoading"]=false
      data["timerState"]=TASK_STATUS.stopped
      data["renderId"]=renderId
      data["created"]=true
      data["editing"]=false
      data["error"] = {
        hasError: false,
        errorType: null,
      }
      tasks[task_index] = {...data}
      state.tasks = [...tasks]
    },
    'SHOW_TASK'(state, {task_id}){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index].editing=false
    },
    'PLAY_TASK'(state, {task_id, countExec=null}){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index]["timerState"]=TASK_STATUS.played
      if(!!countExec){
        state.tasks[task_index]["count_exec"]=countExec
      }
    },
    'PAUSE_TASK'(state, task_id){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index]["timerState"]=TASK_STATUS.paused
    },
    'TIMES_UP_TASK'(state, {task_id, time_exec}){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index]["timerState"]=TASK_STATUS.timesUp;
      state.tasks[task_index]["time_exec"]=time_exec;
    },
    'STOP_TASK'(state, task_id){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index]["timerState"]=TASK_STATUS.stopped
    },
    'FINISH_TASK'(state, {task_id, time_exec}){
      let task_index = state.tasks.findIndex(task => task["id"]==task_id)
      state.tasks[task_index]["timerState"]=TASK_STATUS.stopped
      state.tasks[task_index]["time_exec"]=time_exec;
    },
    'ARCHIVE_TASK'(state, {task_id}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(task => task["id"]==task_id)
      tasks[task_index]["archived"]=true
      state.tasks = [...tasks]
    },
    'UNARCHIVE_TASK'(state, {task_id}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(task => task["id"]==task_id)
      tasks[task_index]["archived"]=false
      state.tasks = [...tasks]
    },
    'SET_DATE_SELECTED'(state, date){
      state.dateSelected=date;
    },
    'TASKS_LOADING_TRUE'(state){
      state.loading=true
    },
    'TASKS_LOADING_FALSE'(state){
      state.loading=false
    },
    'TASK_LOADING_TRUE'(state, {task_id=null, renderId=null}){
      let tasks = [...state.tasks]
      if(!!task_id){
        let task_index = tasks.findIndex(task => task["id"]==task_id)
        tasks[task_index]["isLoading"]=true
        state.tasks = [...tasks]
      }else if(!!renderId){
        let task_index = tasks.findIndex(task => task["renderId"]==renderId)
        tasks[task_index]["isLoading"]=true
        state.tasks = [...tasks]
      }
    },
    'TASK_LOADING_FALSE'(state, {task_id=null, renderId=null}){
      let tasks = [...state.tasks]
      if(!!task_id){
        let task_index = tasks.findIndex(task => task["id"]==task_id)
        tasks[task_index]["isLoading"]=false
        state.tasks = [...tasks]
      }else if(!!renderId){
        let task_index = tasks.findIndex(task => task["renderId"]==renderId)
        tasks[task_index]["isLoading"]=false
        state.tasks = [...tasks]
      }
    },
    'DELETE_TASK'(state, {renderId}){
      state.tasks = [...state.tasks.filter(task => task["renderId"] != renderId)]
    },
    'EMIT_TASK_ERROR'(state, {renderId=null, task_id=null,errorType}){
      let task_index;
      if(!!renderId){
        task_index = state.tasks.findIndex(task => task["renderId"]==renderId)
      }else if(!!task_id){
        task_index = state.tasks.findIndex(task => task["id"]==task_id)
      }
      let tasks = [...state.tasks]
      tasks[task_index].error = {hasError: true, errorType: errorType}
      state.tasks = [...tasks];
    },
    'EMIT_ERROR'(state, {errorType}){
      state.error = { hasError: true, errorType: errorType }
    },
    'ADD_TAG'(state, {renderId=null, tag}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(task => task["renderId"]==renderId)
      tasks[task_index].tags.unshift(tag)
      console.log(tasks[task_index])
      state.tasks = [...tasks];
    },
    'REMOVE_TAG'(state, {renderId=null, task_id=null, tagId}){
      let tasks = [...state.tasks]
      let task_index = tasks.findIndex(task => task["renderId"]==renderId)
      tasks[task_index].tags = tasks[task_index].tags.filter(tag => tag.id != tagId)
      state.tasks = [...tasks]
    },
  },
  getters: {
    getSavedTasks(state){
      return state.tasks.filter(task => task.created && !task.archived)
    },
    getUnArchivedTasks(state){
      return state.tasks.filter(task => !task.archived) 
    },
    getArchivedTasks(state){
      return state.tasks.filter(task => task.archived)
    }
  },
  actions: {
    initStore({commit}, {tasks=null, dateSelected=null, urlBase="", tenantPresent=false}){
      commit('SET_TASKS', tasks);
      commit('SET_DATE_SELECTED', dateSelected);
      commit('SET_URL_BASE', urlBase);
      commit('SET_TENANT_PRESENT', tenantPresent);
    },
    createTask({commit}, {renderId, task, onError=null, onSuccess=null}){
      commit('TASK_LOADING_TRUE', {renderId: renderId})
      apiService.createTask(
        {
          taskData: task,
          onSucess: (response) => {
            commit('CREATE_TASK', {renderId: renderId, data: response.data});
            commit('TASK_LOADING_FALSE', {renderId: renderId})
            onSuccess();
          },
          onError: (error) => { 
            commit('TASK_LOADING_FALSE', {renderId: renderId});
            commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.createError})
          }
        }
      )
    },
    newTask({commit}){
      commit('NEW_TASK');
    },
    editTask({commit}, {task_id}){
      commit('EDIT_TASK', {task_id: task_id});
    },
    updateTask({commit}, {task_id=null, renderId=null, task}){
      commit('TASK_LOADING_TRUE', {renderId: renderId})
      apiService.updateTask(
        {
          taskId: task_id,
          taskData: task,
          onSucess: (response) => {
            commit('CREATE_TASK', {renderId: renderId, data: response.data});
            commit('TASK_LOADING_FALSE', {renderId: renderId})
          },
          onError: (error) => { 
            commit('TASK_LOADING_FALSE', {renderId: renderId });
            commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.updateError})
          }
        }
      )
    },
    showTask({commit}, {task_id}){
      commit('SHOW_TASK', {task_id: task_id})
    },
    playTask({commit, state}, {task_id=null}){
      if(state.tasks.find(task => task.id == task_id).timerState==TASK_STATUS.stopped){
        commit('TASK_LOADING_TRUE', {task_id: task_id})
        apiService.playTask({
          taskId: task_id,
          onSucess: (task) => {
            commit('PLAY_TASK', {task_id: task_id, countExec: task.data.count_exec });
            commit('TASK_LOADING_FALSE', {task_id: task_id})
          },
          onError: (error) => {
            commit('TASK_LOADING_FALSE', {task_id: task_id});
            commit('EMIT_TASK_ERROR', {task_id: task_id, errorType: ERROR_TYPES.playError})
          }
        })
      }else{
        commit('PLAY_TASK', {task_id: task_id });
      }
    },
    pauseTask({commit}, {task_id=null}){
      commit('PAUSE_TASK', task_id);
    },
    stopTask({commit}, {task_id=null}){
      commit('STOP_TASK', task_id);
    },
    timesUpTask({commit}, {task_id=null, renderId=null, onError=null}){
      commit('TASK_LOADING_TRUE', {task_id: task_id})
      apiService.timesUpTask({
        taskId: task_id,
        onSucess: (task) => {
          commit('TIMES_UP_TASK', {task_id: task_id, time_exec:task.data.time_exec});
          commit('TASK_LOADING_FALSE', {task_id: task_id})
        },
        onError: (error) => {
          commit('TASK_LOADING_FALSE', {task_id: task_id})
          commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.timesUpError})
          commit('STOP_TASK', task_id);
        }
      });
    },
    finishTask({commit}, {task_id, elapsedTime}){
      commit('TASK_LOADING_TRUE', {task_id: task_id})
      apiService.finishTask({
        taskId: task_id,
        elapsedTime: elapsedTime,
        onSucess: (task) => {
          commit('FINISH_TASK', {task_id: task_id, time_exec:task.data.time_exec})
          commit('TASK_LOADING_FALSE', {task_id: task_id})
        },
        onError: (error) => {
          commit('TASK_LOADING_FALSE', {task_id: task_id})
          commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.finishError})
          commit('PAUSE_TASK', task_id);
        }
      })
    },
    archiveTask({commit}, {task_id=null, renderId=null}){
      commit('TASK_LOADING_TRUE', {task_id: task_id})
      apiService.archiveTask({
        taskId: task_id,
        onSucess: (task) => {
          commit('ARCHIVE_TASK', {task_id: task_id})
          commit('TASK_LOADING_FALSE', {task_id: task_id})
        },
        onError: (error) => {
          commit('TASK_LOADING_FALSE', {task_id: task_id})
          commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.archiveError})
        }
      })
    },
    unarchiveTask({commit}, {task_id=null}){
      commit('TASKS_LOADING_TRUE')
      apiService.unarchiveTask({
        taskId: task_id,
        onSucess: (task) => {
          commit('UNARCHIVE_TASK', {task_id: task_id})
          commit('TASKS_LOADING_FALSE')
        },
        onError: (error) => {
          commit('TASKS_LOADING_FALSE')
          commit('EMIT_ERROR', {errorType: ERROR_TYPES.unarchiveError})
        }
      })
    },
    setDateSelected({commit, state}, {date=null, setURL=false}){
      commit('TASKS_LOADING_TRUE')
      apiService.listInstanceTask({
        date:date,
        onSucess: (response) => {
          commit('SET_DATE_SELECTED', date);
          commit('SET_TASKS', response.data);
          commit('TASKS_LOADING_FALSE');
          if(setURL){
            let urlBase = state.urlBase;
            let url = `${document.location.origin}${urlBase}?date=${date.getFullYear()}-${(date.getMonth()+1)}-${date.getDate()}`
            history.pushState(null, null, url);
          }
        },
        onError: (response) => {
          commit('EMIT_ERROR', {errorType: ERROR_TYPES.selectDateError})
          commit('TASKS_LOADING_FALSE')
        }
      })
    },
    deleteTask({commit}, {task_id=null, renderId=null}){
      commit('TASK_LOADING_TRUE', { task_id: task_id})
      if(!!task_id){
        apiService.deleteTask({
          taskId: task_id,
          onSucess: (response) => {
            commit('DELETE_TASK', {renderId: renderId})
            commit('TASKS_LOADING_FALSE')
          },
          onError: (response) => {
            commit('TASK_LOADING_FALSE', { task_id: task_id})
            commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.deleteError})
          },
        })
      }else{
        commit('DELETE_TASK', {renderId: renderId})
      }
    },
    addTag({commit}, {task_id=null, renderId=null, tag}){
      if(!!task_id){
        commit('TASK_LOADING_TRUE', { renderId: renderId})
        apiService.addTagTask({
          tagId: tag.id,
          taskId: task_id,
          onSucess: (response) => {
            commit('ADD_TAG', {renderId: renderId, tag: response.data})
            commit('TASK_LOADING_FALSE', {renderId: renderId})
          },
          onError: (response) => {
            commit('TASK_LOADING_FALSE', { renderId: renderId})
            commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.addTagError})
          },
        })
      }else{
        commit('ADD_TAG', {renderId: renderId, tag: tag})
      }
    },
    removeTag({commit}, {task_id=null, renderId=null, tag}){
      if(!!task_id){
        commit('TASK_LOADING_TRUE', { renderId: renderId})
        apiService.removeTagTask({
          tagId: tag.id,
          taskId: task_id,
          onSucess: (response) => {
            commit('REMOVE_TAG', {renderId: renderId, tagId: tag.id})
            commit('TASK_LOADING_FALSE', {renderId: renderId})
          },
          onError: (response) => {
            commit('TASK_LOADING_FALSE', {task_id: task_id})
            commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: ERROR_TYPES.removeTagError})
          }
        })
      }else{
        commit('REMOVE_TAG', {renderId: renderId, tagId: tag.id})
      }
    },
    emitTaskError({commit}, {renderId, errorType}){
      commit('EMIT_TASK_ERROR', {renderId: renderId, errorType: errorType})
    },
    emitError({commit}, {errorType}){
      commit('EMIT_ERROR', {errorType: errorType})
    }
  }
}